import Vue from 'vue'
import App from './App.vue'

if (process.env.VUE_APP_MODE === 'release') {
    Vue.config.debug = false;
    Vue.config.productionTip = false;
    Vue.config.devtools = false;
    Vue.config.silent = false;
    Vue.config.warnHandler = () => {};
    Vue.config.errorHandler = () => {};
}

Vue.prototype.$serverUrl = process.env.VUE_APP_SERVER_URL;

window.$ = window.JQuery = require('jquery');
require("bootstrap");

import axios from "axios";
Vue.prototype.$http = axios;

window.persianDate = require("persian-date");

import VueMeta from 'vue-meta'
Vue.use(VueMeta)

import router from './router'

import store from './store/store'

import './assets/js/font-symbol-defs';

import './assets/js/loading-overlay';

import './registerServiceWorker'

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');
